import { combineReducers } from "redux";
import { FetchUserAttributesOutput } from "aws-amplify/auth";
import AuthReducer, { AuthState } from "./Auth";
import UserProfileReducer from "./UserProfile";
import FeatureFlagReducer, { UserFeatureFlagState } from "./FeatureFlag";
import ProjectsReducer, { ProjectsState } from "./Projects";
import ExecutionReducer, { ExecutionState } from "./Execution";
import AdditionalAssetsReducer, {
  AdditionalAssetsState,
} from "./AdditionalAssets";

export interface reducerType {
  Auth: AuthState;
  UserProfile: FetchUserAttributesOutput;
  FeatureFlag: UserFeatureFlagState[];
  Projects: ProjectsState;
  Execution: ExecutionState;
  AdditionalAssets: AdditionalAssetsState;
}

export default combineReducers<reducerType>({
  Auth: AuthReducer,
  UserProfile: UserProfileReducer,
  FeatureFlag: FeatureFlagReducer,
  Projects: ProjectsReducer,
  Execution: ExecutionReducer,
  AdditionalAssets: AdditionalAssetsReducer,
});
